import React, { useEffect, useState } from 'react';
import { useLocalize } from '@saviynt/common';
import {
  Box,
  Button,
  Checkbox,
  Popover,
  Tooltip,
  Typography,
} from '@saviynt/design-system';

import { msgs } from '../../utilities/messages';

const BULKROLESELCT_POPOVER_DISABLED = 'BULKROLESELCT_POPOVER_DISABLED';

const renderFilterPills = (
  MenuMulti,
  ButtonSelect,
  platform,
  asset,
  role,
  isJitForApps,
  hasSelectedRoles
) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isCheckBoxSelected, setIsCheckBoxSelected] = useState(false);
  const localize = useLocalize();

  useEffect(() => {
    // Check localStorage on component mount to determine if popover should be shown
    const isDisabled =
      localStorage.getItem(BULKROLESELCT_POPOVER_DISABLED) === 'true';

    setIsPopoverOpen(hasSelectedRoles && !isDisabled);
  }, [hasSelectedRoles]);

  const renderPopoverContent = () => (
    <Box className='LandingPage-popoverContent'>
      <Typography kind='h3' className='LandingPage-popoverContentTexts'>
        {localize(msgs.pam.landingPage.bulkRoleSelectPopoverTitle)}
      </Typography>
      <Typography kind='body2' className='LandingPage-popoverContentTexts'>
        {localize(msgs.pam.landingPage.bulkRoleSelectPopoverSubTitle)}
      </Typography>
      <Box className='LandingPage-popoverContentButton'>
        <Checkbox
          size='small'
          label={
            <Typography kind='body3' color='--color-foreground-neutral-bold'>
              {localize(msgs.pam.landingPage.bulkRoleSelectPopoverCheckBox)}
            </Typography>
          }
          textPosition='after'
          isChecked={isCheckBoxSelected}
          onChange={(e) => setIsCheckBoxSelected(e.target.checked)}
        />
        <Button
          size='small'
          onClick={() => {
            if (isCheckBoxSelected)
              localStorage.setItem(BULKROLESELCT_POPOVER_DISABLED, 'true');
            setIsPopoverOpen(false);
          }}>
          {localize(msgs.pam.landingPage.bulkRoleSelectPopoverSubmitButton)}
        </Button>
      </Box>
    </Box>
  );

  return (
    <>
      <MenuMulti
        options={platform.options}
        label={localize(msgs.pam.landingPage.platform)}
        trigger={
          <ButtonSelect
            kind='pill'
            label={localize(msgs.pam.landingPage.platform)}
            widthConfigs={{ maxWidth: '15rem' }}
          />
        }
        onChange={platform.setSelected}
        heightToShowScrollbar='20rem'
        size='medium'
      />
      {!isJitForApps && (
        <MenuMulti
          options={asset.options}
          label={localize(msgs.pam.landingPage.assetType)}
          trigger={
            <ButtonSelect
              kind='pill'
              label={localize(msgs.pam.landingPage.assetType)}
              widthConfigs={{ maxWidth: '15rem' }}
            />
          }
          onChange={asset.setSelected}
        />
      )}
      {!isJitForApps && (
        <Popover
          trigger={
            <Tooltip
              text={localize(
                msgs.pam.landingPage.bulkRoleSelectRoleFilterTooltip
              )}
              placement='top'
              isDisabled={!hasSelectedRoles}
              trigger={
                <MenuMulti
                  options={role.options}
                  label={localize(msgs.pam.landingPage.roleType)}
                  trigger={
                    <ButtonSelect
                      kind='pill'
                      label={localize(msgs.pam.landingPage.roleType)}
                      isDisabled={hasSelectedRoles}
                      widthConfigs={{ maxWidth: '15rem' }}
                    />
                  }
                  onChange={role.setSelected}
                  size='medium'
                />
              }
            />
          }
          placement='right'
          popoverContent={renderPopoverContent()}
          isOpen={isPopoverOpen}
          className='BulkRole-popover'
          classNames={{
            content: 'LandingPage-popoverContent',
          }}
        />
      )}
    </>
  );
};

// eslint-disable-next-line import/prefer-default-export
export { renderFilterPills };
